<template>
  <div
    v-loading.body="userLoading"
    element-loading-text="Fetching page..."
    style="width: 100%;"
  >
    <section class="userlist-header-container">
      <HeaderInfoText :colspan="9" title="USERS" :meta="metaDetails" />
      <el-pagination
        layout="prev, pager, next, jumper"
        :total="total"
        :page-size="page_size"
        v-model:current-page="page"
        @current-change="loadUserList"
      />
      <section style="margin-left: auto;">
        <el-button plain @click="toggleFilters">
          {{ showFilters ? 'Hide filters' : 'Show filters' }}
        </el-button>
        <el-button :disabled="!hasCreatePermission" type="primary" icon="plus" @click="createNewModel()" />
      </section>
    </section>
    <section v-if="showFilters" class="userlist-filter-container">
      <KeywordFilter
        :properties="searchObj"
        style="width: auto;"
      ></KeywordFilter>
    </section>
    <el-table :data="userList" height="100%" border style="height: 100%;">
      <el-table-column prop="username" label="Username">
        <template v-slot="user">
          <span class="link-mock" @click="createNewModel(user.row)">
            {{ user.row.username }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="email" label="Email Address" />
      <el-table-column prop="first_name" label="First Name" />
      <el-table-column prop="last_name" label="Last Name" />
      <el-table-column prop="is_active" label="Status">
        <template v-slot="user">
          <el-tag :type="user.row.is_active ? 'success' : 'danger'" close-transition>
                {{ user.row.is_active ? 'Active' : 'Inactive' }}
              </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <UserForm
      v-if="canShowForm"
      :userDetails="currentUser"
      :hasCreatePermission="hasCreatePermission"
      @onSave="loadUserList"
      @onClose="canShowForm = false"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import UserForm from './UserForm.vue'
import HeaderInfoText from '../../HeaderInfoText.vue'
import KeywordFilter from '../../FilterComponents/KeywordFilter.vue'
import { http } from '@/plugins/http'
import { getHeaders, buildUrlWithQuery } from '@/utils/api'

export default {
  name: 'Users',
  components: {
    UserForm,
    HeaderInfoText,
    KeywordFilter
  },
  data: () => ({
    userList: [],
    userLoading: false,
    canShowForm: false,
    currentUser: null,
    perPage: null,
    page_size: 20,
    page: 1,
    total: null,
    showFilters: true,
    searchText: '',
    searchObj: {},
    filterComponent: [
      {
        type: 'keywordFilter',
        props: {}
      },
      {
        type: 'selectFilter',
        props: {
          filterName: 'active',
          multi: false,
          placeholder: 'Active',
          opts: [
            { label: 'All', value: ' ' },
            { label: 'Active', value: 'True' },
            { label: 'Inactive', value: 'False' }
          ]
        }
      }
    ]
  }),
  created () {
    this.searchObj = {
      sync: value => {
        this.searchText = value
      },
      clear: () => {
        this.searchText = ''
      },
      apply: this.loadUserList
    }
    this.loadUserList()
  },
  computed: {
    ...mapGetters({
      checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions'
    }),
    metaDetails () {
      return { count: this.total, shown: this.perPage }
    },
    hasCreatePermission () {
      return this.checkIfUserHasRequiredPermissions(['auth.view_user', 'auth.add_user'])
    }
  },
  methods: {
    async loadUserList () {
      try {
        this.userLoading = true
        const instanceUrl = this.$store.getters.getActiveInstance.url
        const headers = getHeaders(this.$store.getters.getToken)
        let payload = this.searchText ? { search: this.searchText } : { page: this.page }
        payload.is_staff = false
        let { data } = await http.get(
          buildUrlWithQuery('users', payload, instanceUrl),
          { headers }
        )
        this.userList = data.results || []
        this.total = data.count || null
        this.perPage = data.results.length
      } catch (e) {
      }
      this.userLoading = false
    },
    toggleFilters () {
      this.showFilters = !this.showFilters
    },
    createNewModel (userObj = null) {
      this.currentUser = userObj
      this.canShowForm = true
    }
  }
}
</script>
<style scoped>
.userlist-header-container {
  display: flex;
  align-items: center;
  padding-right: 12px;
  border-bottom: 1px solid lightgray;
}
.userlist-filter-container {
  padding: 12px 4px;
}
</style>
